import { Component, OnInit, ViewChild, ChangeDetectionStrategy, TemplateRef } from '@angular/core';
import { FormGroup, AbstractControl, FormControl, Validators } from '@angular/forms'; 
import { department, interaction, division, user, usermaster, tenant, userpermission } from './../../../models/admin';
import { Users, usergroup, userrights, userType, usergrouptype, pairText } from './../../../models/users';
import { AdminApiService } from './../../../services/admin.service';
import { UtilityService } from './../../../services/utility.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
//import { MatSliderChange } from '@angular/material/slider';
//import { Query } from '@syncfusion/ej2-data';
import Swal from 'sweetalert2'
import { ImgCropperConfig, ImgCropperEvent, LyResizingCroppingImages, ImgCropperErrorEvent, ImgResolution } from '@alyle/ui/resizing-cropping-images';
import { LyTheme2, Platform } from '@alyle/ui';
import 'hammerjs';
import { UserService } from './../../../services/user.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
 
import { EncryptDecrypt } from './../../../models/common';

import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToasterService } from '../../../toaster.service';
import { RSAHelper } from '../../../models/RSAHelper';

const styles = ({
  actions: {
    display: 'flex'
  },
  cropping: {
    maxWidth: '400px',
    height: '300px'
  },
  flex: {
    flex: 1
  },
  range: {
    textAlign: 'center',
    maxWidth: '500px',
    margin: '14px'
  }
});
 
@Component({
  selector: 'app-usermaster',
  templateUrl: './usermaster.component.html',
  styleUrls: ['./usermaster.component.css']

})
export class UserMasterComponent implements OnInit {
  public isSubmitted: boolean = false;
  columnDefinitions: Column[];
  gridOptions: GridOption;
  public loading: boolean = true;
  angularGrid: AngularGridInstance;
  dataset: any;
  searchText: string;
  dataSearch: any;
  modalRef: BsModalRef;
  modalUserRef: BsModalRef;
  @ViewChild('editSettingsTemplate', { static: false }) editTemplate: TemplateRef<any>;
  @ViewChild('entrytemplate', { static: false }) entrytemplate: TemplateRef<any>;
  public title: string = 'Add Role';
  public user_data: any;
  public division_data: any;
  public Userdivision_data: any;
  public usertype_data: any;
  public usergroup_data: any;
  public editSettings: Object;
  public toolbar: string[];
  public pageSettings: Object;
  public orderData: object;
  public interactionData: object[];
  public tenant_data: any;
  public usermasterForm: FormGroup;
  public submitClicked: boolean = false;
  public pageAction: string = 'add';
  public ntUser: string = '';
  public ntUserData: any;
  public iseditmode: boolean = false;
  public isPRSearch: boolean = false;
  public selTab: boolean = true;
 
  public permission: number = 1;
  public tenantNumber: string = '';
  public userType: string = '';
  public userRole: string = '';
  public division: string = '';

  //for Image
  croppedImage?: string;
  result: string;
  scale: number = 0.1;
  classes = this.theme.addStyleSheet(styles);
  public condition2_data: any;
  @ViewChild(LyResizingCroppingImages, { static: false }) cropper: LyResizingCroppingImages;
  myConfig: ImgCropperConfig = {
    autoCrop: true,
    width: 250, // Default `250`
    height: 200, // Default `200`
    fill: '#ffffff', // Default transparent if type = png else #000,
    type: 'image/jpeg',
    //output: ImgResolution.OriginalImage // Default ImgResolution.Default
  };

  user: any = {};
  isAdmin: boolean = false;
  isSLAAdmin: boolean = false;
  login_UserID: string = '';
  public tempuseraccess: boolean = false;
  noDataImg: any;
  tenantUno: any;
  
    exUser: boolean=false;
    externalUser: number=0;
  selectedUserUno: any=0;
    userpermission_data: any=[];
    isEditOnly: boolean=false;
    selectedUserTenantUno: any;
    strK1: string;
    strI1: string;
  createdBy: string='';
  createdOn: string = '';
  modifiedBy: string = '';
  modifiedOn: string = '';
  constructor(public restApi: AdminApiService, public utilityService: UtilityService, private toaster: ToasterService,private router: Router, private acroute: ActivatedRoute,
    private spinner: SpinnerVisibilityService, private theme: LyTheme2, private userService: UserService, private modalService: BsModalService, public RASHelper: RSAHelper) {
    //To Validate User Permission
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.isEditOnly = (  this.user.role == 'DDAdmin' || this.user.role == 'BM Administrator') ? true : false;
    this.isAdmin = (this.user.role == 'Administrator') ? true : false;
    this.isSLAAdmin = (this.user.role == 'SLA Admin') ? true : false;
    if (!this.isAdmin && !this.isEditOnly && !this.isSLAAdmin) {
      this.router.navigateByUrl('/access-denied');
    }

    this.acroute.queryParams
      .subscribe(params => {

        if (params.isusermanage != undefined && params.isusermanage != null)
          this.tempuseraccess = true;

      }
      );

  }

  ngOnInit() {
    this.userService.CheckLogin();
    this.loadpairText();
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };

    //SLA Admin
    if (this.isSLAAdmin) {

      let tenantUno = this.user.tenantUno;
      tenantUno = (tenantUno != null && tenantUno != undefined) ? tenantUno : 0;
      this.getDivisions(tenantUno);
    } else {
      this.getDivisions(0);
    }
   
    this.getUserGroupType();
    //this.getUserType();
    //this.getUserGroup();
    this.getCondition();
    this.loadTenant(0);
    this.editSettings = { allowEditing: true, allowAdding: true, allowDeleting: true, mode: 'Dialog' };
    
    if (this.permission == 1) {
      this.toolbar = ['Add', 'Edit', 'Delete', 'Update', 'Cancel', 'Search', 'ExcelExport'];
    }
    else
      this.toolbar = ['Search', 'ExcelExport'];

    this.pageSettings = { pageSize: 20, pageSizes: true };
    // this.interactionData = DataUtil.distinct(this.data, 'id', true);

    this.loadUserMaster();
    this.loadNTUserMaster();
  }

  // Get user list
  loadUserMaster() {
    this.spinner.show();
    let inpValue = new usermaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = (this.isAdmin)?11:1;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    inpValue.ntLogin = this.user.username;
    
    this.restApi.getUserMasters(inpValue)
      .subscribe(data => {
        
        let rtnData: any = data;
        if (rtnData.data.length > 0) {
          this.user_data = rtnData.data;
        }
        //this.user_data = data;
        const mockDataset = [];
        for (let i = 0; i < this.user_data.length; i++) {
          mockDataset[i] = {
            id: i + 1,
            userUno: this.user_data[i].userUno,
            ntUsername: this.user_data[i].ntUsername,
            displayNameEn: this.user_data[i].displayNameEn,
            displayNameAr: this.user_data[i].displayNameAr,
            userPhoto: this.user_data[i].userPhoto,
            userTypeNameEn: this.user_data[i].userTypeNameEn,
            emailId: this.user_data[i].emailId,
            firstname: this.user_data[i].firstname,
            usergroupEn: this.user_data[i].usergroupEn,
            lastname: this.user_data[i].lastname,
            designationEn: this.user_data[i].designationEn,
            designationAr: this.user_data[i].designationAr,
            divisionNameEn: this.user_data[i].divisionNameEn,
            divisionUno: this.user_data[i].divisionUno,
            usergroupUno: this.user_data[i].usergroupUno,
            userenable: this.user_data[i].userenable,
            welcomeEmailSEND: this.user_data[i].welcomeEmailSEND,
            userTypeUno: this.user_data[i].userTypeUno,
            tenantUno: this.user_data[i].tenantUno,
            createdBy: this.user_data[i].createdBy,
            createdOn: this.user_data[i].createdOn,
            modifiedBy: this.user_data[i].modifiedBy,
            modifiedOn: this.user_data[i].modifiedOn,
            //: this.user_data[i].externalUser

          };
        }
        this.dataset = mockDataset;
        this.dataSearch = mockDataset;
        if (mockDataset.length > 0) {
          this.setColnDefn();
        }
        this.loading = false;
        this.spinner.hide();

      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  // Get user list
  loadNTUserMaster() {
    this.spinner.show();
    let inpValue = new usermaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 5;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;

    this.restApi.getUserMasters(inpValue)
      .subscribe(data => {
        let rtnData: any = data;
        if (rtnData.data.length > 0) {
          this.ntUserData = rtnData.data;
        }
        //this.ntUserData = data;
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  // Get tenant list
  loadTenant(tenantUno:any) {
    this.spinner.show();
    let inpValue = new tenant();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;

    
    this.restApi.getTenants(inpValue)
      .subscribe(data => {
        

        let rtnData: any = data;
        if (tenantUno > 0) {
          this.tenant_data = rtnData.filter(x => x.tenantUno != tenantUno);
        } else {
          this.tenant_data = rtnData;
        }
        //Sla Admin
        if (this.isSLAAdmin) {
          this.tenant_data = (rtnData != null && rtnData.length > 0) ? rtnData.filter(x => x.tenantUno == this.tenantUno) : [];
        }
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  // Get user list
  bindNTUserMaster_selectedUser(ntLogin: string) {
    this.spinner.show();
    let inpValue = new usermaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 6;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    inpValue.ntLogin = ntLogin;
    
    this.restApi.getUserMasters(inpValue)
      .subscribe(data => {
        
        // this.ntUserData = data[0];
        let rtnData: any = data;
        
        if (rtnData.data[0] != undefined) {
          this.usermasterForm = this.createFormGroup(rtnData.data[0]);
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
    return true;
  }
  sendWelcomeEmail(useruno: any) {
    this.spinner.show();
    let inpValue = new usermaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.userUno = this.RASHelper.encryptWithPublicKey(useruno);
    inpValue.enteredBy = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    
    this.restApi.sendWelcomeEmailToUsers(inpValue)
      .subscribe(data => {
        //Swal.fire({
        //  type: 'success',
        //  title: 'Email sent.',
        //  showConfirmButton: false,
        //  timer: 1500
        //})
        this.toaster.show('success', 'Success', 'Email sent.');
        this.spinner.hide();
        this.loadUserMaster();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  getDivisions(tenantUno:number) {
    let inpValue = new division();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 4;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getDivisions(inpValue)
      .subscribe(data => {
        
        let rtnData:any = data;
        if (tenantUno > 0) {
          this.division_data = rtnData.filter(x => x.tenantUno == tenantUno);
        } else {
          this.division_data = rtnData;
        }
        
        
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getDivisionsByTenantUno(tenantUno: number) {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = tenantUno;
    this.restApi.getDivisions(inpValue)
      .subscribe(data => {
        this.Userdivision_data = [];
        let rtnData: any = data;
        //if (tenantUno > 0) {
        //  this.Userdivision_data = rtnData.filter(x => x.tenantUno == tenantUno);
        //} else {
        //  this.Userdivision_data = rtnData;
        //}
        this.Userdivision_data = rtnData;

      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  //getUserType() {
  //  this.usertype_data = [
  //    { id: 1, name: 'Administrator' },
  //    { id: 2, name: 'User' },
  //    { id: 3, name: 'SLA Admin' },
  //    { id: 4, name: 'SLA Coordinator' },
  //    { id: 5, name: 'BM Champions' },
  //    { id: 6, name: 'BM Administrator' },
  //    { id: 7, name: 'BM Team' },
  //    { id: 8, name: 'BM Visitor' },
  //    { id: 9, name: 'DDAdmin' },
  //    { id: 10, name: 'DDAdminReadonly' }
      
  //  ]
  //}
  onchangeDropDown(e) {
    this.isSubmitted = false;
    
  }
  onchangeTenantDropDown(e) {
    this.isSubmitted = false;
    debugger;
    this.getDivisionsByTenantUno(parseInt(this.tenantNumber));
  }
  getUserGroupType() {
    
    let inpValue = new usergrouptype();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = 1;
    this.restApi.getUserGroupType(inpValue)
      .subscribe(data => {
        
        let rtnData:any = data;
        if (rtnData.length > 0) {
          this.usergroup_data = rtnData[0].list_UserGroup;
          this.usertype_data = rtnData[0].list_UserType;
        }
       // this.usergroup_data = data;

        
        
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });

    //this.usergroup_data = [
    // { id: 1, name: 'User Group 1' },
    //{ id: 2, name: 'User Group 2' }
    //]
  }


  getUserGroup() {
    let inpValue = new usergroup();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = 1;
    this.restApi.getUserGroups(inpValue)
      .subscribe(data => {
        this.usergroup_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });

    //this.usergroup_data = [
    // { id: 1, name: 'User Group 1' },
    //{ id: 2, name: 'User Group 2' }
    //]
  }


  getUserType() {
    let inpValue = new userType();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getUserType(inpValue)
      .subscribe(data => {
        this.usertype_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });

    //this.usergroup_data = [
    // { id: 1, name: 'User Group 1' },
    //{ id: 2, name: 'User Group 2' }
    //]
  }
  createFormGroup(data1: any): FormGroup {
    debugger;
    
    if (data1.userPhoto != null && data1.userPhoto != '' && data1.userPhoto != '/assets/img/user-default.png') {
      this.croppedImage = data1.userPhoto;
    }
    
    let selecttenantUno = (data1.tenantUno) ? this.utilityService.CommaSeperatorToArrayParseInt(data1.tenantUno.toString()) : [];

    //Division filter based on user tenantuno
   
      let tenantUno = (data1.tenantUno) ? selecttenantUno[0] : 0;

    this.getDivisions(tenantUno);

      
    


    return new FormGroup({
      userUno: new FormControl(data1.userUno),
      ntUsername: new FormControl(data1.ntUsername),
      displayNameEn: new FormControl(data1.displayNameEn, Validators.required),
      displayNameAr: new FormControl(data1.displayNameAr, Validators.required),
      firstname: new FormControl(data1.firstname),
      lastname: new FormControl(data1.lastname),
      emailId: new FormControl(data1.emailId, Validators.email),
      designationEn: new FormControl(data1.designationEn),
      designationAr: new FormControl(data1.designationAr),
      userTypeUno: new FormControl(data1.userTypeUno, Validators.required),
      strTenantUno: new FormControl(selecttenantUno, Validators.required),
      divisionUno: new FormControl(data1.divisionUno, Validators.required),
      usergroupUno: new FormControl(data1.usergroupUno, Validators.required),
      userenable: new FormControl(data1.userenable),
      
      userPhoto: new FormControl(data1.userPhoto)
    });
  }
  addItem() {

    this.isPRSearch = false;
    this.exUser = false;
    this.externalUser = 0;


    this.modalRef = this.modalService.show(
      this.editTemplate,
      Object.assign({}, {
        class: 'gray modal-xl',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
    this.pageAction = "add";
    this.iseditmode = false;
    this.submitClicked = false;
    this.croppedImage = '';
    this.title = 'Add User';
    this.usermasterForm = new FormGroup({
      userUno: new FormControl(0),
      ntUsername: new FormControl(null),
      displayNameEn: new FormControl(null, Validators.required),
      displayNameAr: new FormControl(null, Validators.required),
      firstname: new FormControl(null),
      lastname: new FormControl(null),
      emailId: new FormControl(null, Validators.email),
      designationEn: new FormControl(null),
      designationAr: new FormControl(null),
      userTypeUno: new FormControl(null, Validators.required),
      divisionUno: new FormControl(null, Validators.required),
      usergroupUno: new FormControl(null, Validators.required),
      strTenantUno: new FormControl(null, Validators.required),
      password: new FormControl(null),
      confirmPassword: new FormControl(null),
      userenable: new FormControl(null),
      userPhoto: new FormControl(null)
    });

    this.createdBy = '';
    this.createdOn = '';
    this.modifiedBy = '';
    this.modifiedOn = '';
  }

  editItem(data) {
    
    this.pageAction = "edit";
    this.submitClicked = false;
    this.croppedImage = '';
    this.title = 'Details of ' + data.displayNameEn;
    this.ntUser = data.ntUsername;
    this.iseditmode = true;
    //if (data.externalUser == 1) {
    //  this.exUser = true;

    //}
    this.createdBy = '';
    this.createdOn = '';
    this.modifiedBy = '';
    this.modifiedOn = '';

    this.createdBy = data.createdBy;
    this.createdOn = data.createdOn;
    this.modifiedBy = data.modifiedBy;
    this.modifiedOn = data.modifiedOn;

    this.usermasterForm = this.createFormGroup(data);
    this.modalRef = this.modalService.show(
      this.editTemplate,
      Object.assign({}, {
        class: 'gray modal-xl',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }
  saveUser(): void {
    
    this.submitClicked = true;
    if (this.usermasterForm.valid) {
      let data = this.usermasterForm.value;
      if (this.pageAction == "add") {

        //externalUser
        if (this.externalUser == 1) {
          if (!(this.checkPassword(data.password))) {
            this.toaster.show('error', 'Error', 'Password should have minimum 8 characters, at least 1 uppercase letter, 1 lowercase letter, 1 number,1 special character.');

          } else if (!(data.password == data.confirmPassword)) {
            this.toaster.show('error', 'Error', 'Passwords do not match.');
          }
          else {
            this.AddEditUserMaster(data);
          }
        }
        else {
          this.AddEditUserMaster(data);
        }


      }
      else { this.AddEditUserMaster(data);}
    }
    else {
      //Swal.fire('Error', 'Enter the required values', 'error')
      this.toaster.show('error', 'Error', 'Enter the required values.');
  }
}
  

  AddEditUserMaster(data1: any) {

    
    let objUser = new usermaster();
    objUser.actionType = this.pageAction;
    objUser.userUno = (this.pageAction == "add") ? this.RASHelper.encryptWithPublicKey('0') : this.RASHelper.encryptWithPublicKey(data1.userUno.toString());
    objUser.ntUsername = this.utilityService.isStringNull(this.ntUser); //data1.ntUsername
    objUser.displayNameEn = this.utilityService.isStringNull(data1.displayNameEn);
    objUser.displayNameAr = this.utilityService.isStringNull(data1.displayNameAr);
    objUser.emailId = this.utilityService.isStringNull(data1.emailId);
    objUser.firstname = this.utilityService.isStringNull(data1.firstname);
    objUser.lastname = this.utilityService.isStringNull(data1.lastname);
    objUser.designationEn = this.utilityService.isStringNull(data1.designationEn);
    objUser.designationAr = this.utilityService.isStringNull(data1.designationAr);
    objUser.userTypeUno = this.utilityService.isNumericNull(data1.userTypeUno);
    objUser.usergroupUno = this.utilityService.isNumericNull(data1.usergroupUno);
    objUser.divisionUno = this.utilityService.isNumericNull(data1.divisionUno);
    objUser.userenable = (data1.userenable != null && data1.userenable != '') ? data1.userenable : 'True';
    objUser.userPhoto = (this.croppedImage != null && this.croppedImage != '') ? this.croppedImage : '';
    objUser.enteredBy = this.utilityService.isStringNull(this.login_UserID);
    objUser.externalUser = this.externalUser;
    

    if (data1.password != undefined && data1.password != null && data1.password != '') {
      let password = this.RASHelper.encryptWithPublicKey(data1.password);
      let confirmPassword = this.RASHelper.encryptWithPublicKey(data1.confirmPassword);
      objUser.password = this.utilityService.isStringNull(password);
      objUser.confirmPassword = this.utilityService.isStringNull(confirmPassword);
    }
    objUser.tenantUno = (data1.strTenantUno) ? data1.strTenantUno.toString() : '';
    //objUser.tenantUno = (this.externalUser == 1) ? this.user.tenantDigitalUno :this.tenantUno;
    
    if (this.externalUser == 1) {
      objUser.ntUsername = this.utilityService.isStringNull(data1.ntUsername);
    }
    
    this.restApi.addEditUserMaster(objUser)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
          //Swal.fire('Error', 'Something went wrong!', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong!');
        }
        else {
          this.toaster.show('success', 'Success', 'User saved.');
          //Swal.fire({
          //  type: 'success',
          //  title: 'User saved.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.loadUserMaster();
          this.loadNTUserMaster;
          this.modalRef.hide();
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }

  DeleteInteraction(data1: any) {

    let objUser = new usermaster();
   // objInteraction.actionType = this.pageAction;
    //objInteraction.interactionUno = data1[0].userUno;   
    objUser.userUno = this.RASHelper.encryptWithPublicKey(data1.userUno);
    objUser.enteredBy = this.login_UserID;
    objUser.tenantUno = this.tenantUno;
    
    this.restApi.deleteUserMaster(objUser)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
          //Swal.fire('Error', 'Something went wrong!', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong!');
        }
        else {
          //Swal.fire({
          //  type: 'success',
          //  title: 'User deleted.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.toaster.show('success', 'Success', 'User deleted.');
          this.loadUserMaster();
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }



  public focusIn(target: HTMLElement): void {
    target.parentElement.classList.add('e-input-focus');
  }

  public focusOut(target: HTMLElement): void {
    target.parentElement.classList.remove('e-input-focus');
  }
   

 

  onCropped(e: ImgCropperEvent) {
    
    this.croppedImage = e.dataURL;
    
  }
  onloaded(e: ImgCropperEvent) {
    
  }
  onerror(e: ImgCropperErrorEvent) {
    
  }
  formatLabel(value: number | null) {
    if (!value) {
      return 0;
    }

    if (value >= 1) {
      return Math.round(value / 1) + '%';
    }

    return value;
  }
  //onSliderInputChange(event: MatSliderChange) {
  //  
  //  this.scale =event.value;
  //}
  //public onFilteringNTUser: any = (e: FilteringEventArgs) => {
  //  // take text for highlight the character in list items.   
  //  let query: Query = new Query().select(['ntUsername', 'value']);
  //  query = (e.text !== '') ? query.where('ntUsername', 'startswith', e.text, true) : query;
  //  e.updateData(this.ntUserData, query);
  //};
  onchangeNTUser(e) {

    
    this.usermasterForm.value.ntUsername = (e && e.length > 0) ? e[0].value : "";

    this.ntUser = (this.usermasterForm.value.ntUsername  != null) ? this.usermasterForm.value.ntUsername : '';
    if (this.ntUser != '') {
      this.bindNTUserMaster_selectedUser(this.ntUser);
    }
    return false;
    //this.currentYear = this.yearUno;
   //if (!this.isStart) { this.loadKPIInbox(); }
  }
  get ntUsername(): AbstractControl { return this.usermasterForm.get('ntUsername'); }
  get displayNameEn(): AbstractControl { return this.usermasterForm.get('displayNameEn'); }
  get displayNameAr(): AbstractControl { return this.usermasterForm.get('displayNameAr'); }

  //get firstname(): AbstractControl { return this.usermasterForm.get('firstname'); }
  //get lastname(): AbstractControl { return this.usermasterForm.get('lastname'); }
  get emailId(): AbstractControl { return this.usermasterForm.get('emailId'); }
  //get designationEn(): AbstractControl { return this.usermasterForm.get('designationEn'); }
  //get designationAr(): AbstractControl { return this.usermasterForm.get('designationAr'); }
  get userTypeUno(): AbstractControl { return this.usermasterForm.get('userTypeUno'); }
  get divisionUno(): AbstractControl { return this.usermasterForm.get('divisionUno'); }
  get userenable(): AbstractControl { return this.usermasterForm.get('userenable'); }
  get usergroupUno(): AbstractControl { return this.usermasterForm.get('usergroupUno'); }
  get password(): AbstractControl { return this.usermasterForm.get('password'); }
  get confirmPassword(): AbstractControl { return this.usermasterForm.get('confirmPassword'); }
  get strTenantUno(): AbstractControl { return this.usermasterForm.get('strTenantUno'); }



  //Authendicate Ad user
  AdLogin(userName:any) {
   
    let objusers = new Users;
    if (userName!=null) {
      this.spinner.hide();
      
     // localStorage.setItem('accessinfo', '{"token":"' + objdata.token + '"}');
      //load user property values

      objusers.userName = this.RASHelper.encryptWithPublicKey(userName);
      objusers.tenantUno = 1;
      objusers.isLogin = false;
      this.restApi.GetUserInfo_ByUserID(objusers).subscribe(
        data => {

          let objdata: any = data;
          if (objdata != null && objdata.length > 0) {

            //Get User default information
            var userid = data[0].id;
            //var displayname = (data[0].displayName != null && data[0].displayName != '') ? objEncryptDecrypt.DecryptText(data[0].displayName, this.strI1, this.strI1) : '';
            //var username = (data[0].userName != null && data[0].userName != '') ? objEncryptDecrypt.DecryptText(data[0].userName, this.strI1, this.strI1) : '';
            //var firstname = (data[0].firstName != null && data[0].firstName != '') ? objEncryptDecrypt.DecryptText(data[0].firstName, this.strI1, this.strI1) : '';
            //var lastname = (data[0].lastname != null && data[0].lastname != '') ? objEncryptDecrypt.DecryptText(data[0].lastname, this.strI1, this.strI1) : '';
            //var email = (data[0].emailId != null && data[0].emailId != '') ? objEncryptDecrypt.DecryptText(data[0].emailId, this.strI1, this.strI1) : '';
            //var role = (data[0].role != null && data[0].role != '') ? objEncryptDecrypt.DecryptText(data[0].role, this.strI1, this.strI1) : '';
            //var desingation = (data[0].designation != null && data[0].designation != '') ? objEncryptDecrypt.DecryptText(data[0].designation, this.strI1, this.strI1) : '';
            //var division = (data[0].division != null && data[0].division != '') ? objEncryptDecrypt.DecryptText(data[0].division, this.strI1, this.strI1) : '';

            var displayname = (data[0].displayName != null && data[0].displayName != '') ? (data[0].displayName) : '';
            var username = (data[0].userName != null && data[0].userName != '') ? (data[0].userName) : '';
            var firstname = (data[0].firstName != null && data[0].firstName != '') ? (data[0].firstName) : '';
            var lastname = (data[0].lastname != null && data[0].lastname != '') ? (data[0].lastname) : '';
            var email = (data[0].emailId != null && data[0].emailId != '') ? (data[0].emailId) : '';
            var role = (data[0].role != null && data[0].role != '') ? (data[0].role) : '';

            // var token = data[0].token;
            var picture = data[0].profilePicture;
            var desingation = (data[0].designation != null && data[0].designation != '') ? (data[0].designation) : '';
            var division = (data[0].division != null && data[0].division != '') ? (data[0].division) : '';


           
            var divisionUno = (data[0].divisionUno != null && data[0].divisionUno != '') ? data[0].divisionUno : 0;
            var versionNumber = (data[0].versionNo != null && data[0].versionNo != '') ? data[0].versionNo : '1.0';

            var currentYear = (data[0].currentYear != null && data[0].currentYear != '') ? data[0].currentYear : '1';
            var currentHalf = (data[0].currentHalf != null && data[0].currentHalf != '') ? data[0].currentHalf : '1';
            var currentQuarter = (data[0].currentQuarter != null && data[0].currentQuarter != '') ? data[0].currentQuarter : '1';
            var currentMonth = (data[0].currentMonth != null && data[0].currentMonth != '') ? data[0].currentMonth : '1';
            var wellperformKPIRange = (data[0].wellperformKPIRange != null && data[0].wellperformKPIRange != '') ? data[0].wellperformKPIRange : '85';
            var userGroupUno = (data[0].userGroupUno != null && data[0].userGroupUno != '') ? data[0].userGroupUno : 0;
            var userGroup = (data[0].userGroupName != null && data[0].userGroupName != '') ? data[0].userGroupName : '';
            var userTypeUno = (data[0].userTypeUno != null && data[0].userTypeUno != '') ? data[0].userTypeUno : 0;
            var userroleType = (userTypeUno != null && userTypeUno != undefined && userTypeUno != '') ? userTypeUno : 0;
            var lastLogin = (data[0].lastLogin != null && data[0].lastLogin != '') ? data[0].lastLogin : '';
            //role = (userTypeUno == 1) ? 'Administrator' : (userTypeUno == 2) ? 'User' : (userTypeUno == 3) ? 'SLA Admin' : (userTypeUno == 4) ? 'SLA Coordinator' : 'User';
            role = (data[0].userTypeNameEn != null && data[0].userTypeNameEn != '') ? data[0].userTypeNameEn : 'User';

            var isDynamicEntry = (data[0].isDynamicentry != null && data[0].isDynamicentry != '') ? data[0].isDynamicentry : 'false';
            var siteHeading = (data[0].siteHeading != null && data[0].siteHeading != '') ? data[0].siteHeading : 'Musherat';
            var slaname = (data[0].slaname != null && data[0].slaname != '') ? data[0].slaname : 'SLA';
            

            //TenantUser --For  Digital Dewa
            var tenantUno = (data[0].tenantUno != null && data[0].tenantUno != '') ? data[0].tenantUno : 1;
            var tenantDigitalUno = (data[0].tenantDigitlalUno != null && data[0].tenantDigitlalUno != '') ? data[0].tenantDigitlalUno : 2;

            var isDigitalUser = (tenantUno == tenantDigitalUno) ? true : false;
            this.tenantUno = tenantUno;
            
            //Assign User value to the Session
            let password = '';
          /*var struser = '{"id":"' + userid + '","displayname":"' + displayname + '","username":"' + username + '","firstname":"' + firstname + '","lastname":"' + lastname + '","email":"' + email + '","role":"' + role + '","desingation":"' + desingation + '","division":"' + division + '","profilePicture":"' + picture + '","currentYear":"' + currentYear + '","currentHalf":"' + currentHalf + '","password":"' + password + '","currentQuarter":"' + currentQuarter + '","currentMonth":"' + currentMonth + '","versionNumber":"' + versionNumber + '","wellperformKPIRange":"' + wellperformKPIRange + '","lastLogin":"' + lastLogin + '"}';*/

            var struser = '{"id":"' + userid + '","tenantDigitalUno":"' + tenantDigitalUno + '","tenantDigitalUser":"' + isDigitalUser + '","displayname":"' + displayname + '","username":"' + username + '","firstname":"' + firstname + '","lastname":"' + lastname + '","email":"' + email + '","role":"' + role + '","desingation":"' + desingation + '","division":"' + division + '","divisionUno":"' + divisionUno + '","profilePicture":"' + picture + '","currentYear":"' + currentYear + '","currentHalf":"' + currentHalf + '","currentQuarter":"' + currentQuarter + '","currentMonth":"' + currentMonth + '","versionNumber":"' + versionNumber + '","wellperformKPIRange":"' + wellperformKPIRange + '","lastLogin":"' + lastLogin + '","tenantUno":"' + this.tenantUno + '","isDynamicEntry":"' + isDynamicEntry + '","siteHeading":"' + siteHeading + '","slaname":"' + slaname + '","userroleType":"' + userroleType + '","userGroupUno":"' + userGroupUno + '","userGroup":"' + userGroup + '"}';


          

            localStorage.removeItem('userinfo');
            localStorage.setItem('userinfo', struser);
            var elementElBacktoTop = document.getElementById('elbacktotop') as HTMLInputElement;
            if (elementElBacktoTop != null) {
              elementElBacktoTop.style.display = "block";
            }

            this.loadUserRights(userid, userGroupUno);


          }
          else {

            //Swal.fire('Error', 'Your Account is locked or not matched, contact your system administrator.', 'error')
            this.toaster.show('error', 'Error', 'Your Account is locked or not matched, contact your system administrator.');
          }
        });

    }
    else {
      //Swal.fire('Error', 'Invalid username or password. Please try again later or contact your system administrator.');
      this.toaster.show('error', 'Error', 'Invalid username or password. Please try again later or contact your system administrator.');
      this.spinner.hide();
    }

  }

  loadUserRights(userUno, userGroupUno) {

    this.spinner.show();
    let inpValue = new userrights();
    inpValue.languageUno = 1033;
    inpValue.condition = 1;
    inpValue.tenantUno = 1;
    inpValue.userUno = this.RASHelper.encryptWithPublicKey(userUno);
    inpValue.enteredBy = this.login_UserID;
    inpValue.pageUno = 0;
    inpValue.usergroupUno = userGroupUno;

    this.restApi.getUserRights(inpValue)
      .subscribe(data => {
        
        //this.userRights_data = data;

        //Assign User Rights value to the Session
        // var struserrights = '{"userrights_data":"' + JSON.stringify(data) + '"}';
        var struserrights = JSON.stringify(data);
        localStorage.removeItem('userrights');
        localStorage.setItem('userrights', struserrights);

        //var strTenant = '{"id":"' + 1 + '"}';
        //localStorage.removeItem('switchTenant');
        //localStorage.setItem('switchTenant', strTenant);
        //this.getTenantInfo(this.tenantUno);
        setTimeout(() => {
          
      
            window.location.href = "#/dashboard";
            window.location.reload();
        }, 1000);


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  checkPassword(str) {
  var re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
  return re.test(str);
}
  exportToExcel() {
    
    var temp = this;
    setTimeout(function () {
      temp.angularGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }


  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val;
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }
  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'userUno', name: 'User Code', field: 'userUno', sortable: true, maxWidth: 100,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'userUno', 'userUno'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'ntUsername', name: 'User Name', field: 'ntUsername', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'ntUsername', 'ntUsername'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'displayNameEn', name: 'Display Name', field: 'displayNameEn', sortable: true,
        type: FieldType.string, filterable: true, formatter: this.nameFormatter,
        filter: {
          collection: this.uniqueArray(this.dataset, 'displayNameEn', 'displayNameEn'),
          model: Filters.multipleSelect,
        }
      },

      {
        id: 'userTypeNameEn', name: 'User Type', field: 'userTypeNameEn', sortable: true,
        type: FieldType.string, filterable: true, 
        filter: {
          collection: this.uniqueArray(this.dataset, 'userTypeNameEn', 'userTypeNameEn'),
          model: Filters.multipleSelect,
        }
      },

      {
        id: 'emailId', name: 'Email ID', field: 'emailId', sortable: true,
        type: FieldType.string, filterable: true, 
        filter: {
          collection: this.uniqueArray(this.dataset, 'emailId', 'emailId'),
          model: Filters.multipleSelect,
        }
      },

      {
        id: 'usergroupEn', name: 'User Group', field: 'usergroupEn', sortable: true, maxWidth: 125,
        type: FieldType.string, filterable: true, 
        filter: {
          collection: this.uniqueArray(this.dataset, 'usergroupEn', 'usergroupEn'),
          model: Filters.multipleSelect,
        }
      },



      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', maxWidth: 75,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'edit-row', titleKey: 'edit_row', positionOrder: 62, title: 'Edit',

              iconCssClass: 'fa fa-edit fa-lg ', cssClass: 'green-text', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                if (this.permission == 1 )
                  return true;
                else false;
              },
              action: (e, args) => {
                this.loadTenant(0);
                this.editItem(args.dataContext);
              }
            },
            {
              command: 'entry-row', titleKey: 'Entry_ROW', positionOrder: 62, title: 'User Permission',
              iconCssClass: 'fa fa-plus-circle', cssClass: 'blue', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let rdata = args.dataContext;
                
                if (this.permission == 1 && this.user.role == 'Administrator')
                  return true;
                else false;
              },
              action: (e, args) => {
                this.pageAction = 'entry';
                
                let rdata: any = args.dataContext;

                let selecttenantUno = (rdata.tenantUno) ? this.utilityService.CommaSeperatorToArrayParseInt(rdata.tenantUno.toString()) : [];
                let tenantUno = (rdata.tenantUno) ? selecttenantUno[0] : 0;
                this.loadTenant(tenantUno);
                this.selectedUserUno = rdata.userUno;
                
                this.getUserPermissionEntry(this.selectedUserUno);
                this.getDivisionsByTenantUno(this.tenantUno);
                this.clearEntryForm();
                this.modalUserRef = this.modalService.show(
                  this.entrytemplate,
                  Object.assign({}, {
                    class: 'gray modal-lg',
                    backdrop: true,
                    keyboard: true,
                    focus: true,
                    show: false,
                    ignoreBackdropClick: true,
                    animated: true
                  })
                );
              }
            },
            {
              command: 'send-row', titleKey: 'send_row', positionOrder: 63, title: 'Send Welcome Email',

              iconCssClass: 'fa fa-send fa-lg ', cssClass: 'green-text', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                if ((data.welcomeEmailSEND == null || data.welcomeEmailSEND == '' || data.welcomeEmailSEND == '0' || data.welcomeEmailSEND == 'False') && this.isAdmin)
                  return true;
                else false;
              },
              action: (e, args) => {
                this.sendWelcomeEmail(args.dataContext.userUno);
              }
            },

            {
              command: 'temp-row', titleKey: 'temp_row', positionOrder: 64, title: 'Temp User Access',

              iconCssClass: 'fa fa-send fa-lg ', cssClass: 'green-text', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                if (this.tempuseraccess)
                  return true;
                else false;
              },
              action: (e, args) => {
                this.AdLogin(args.dataContext.ntUsername);
              }
            },

            {
              command: 'delete-row', titleKey: 'del_row', positionOrder: 65, title: 'Delete',
              iconCssClass: 'fa fa-trash fa-lg ', cssClass: 'red', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                if (this.permission == 1 && (this.isAdmin || this.isSLAAdmin))
                  return true;
                else false;
              },
              action: (e, args) => {
                Swal.fire({
                  text: 'Please confirm to delete',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    this.pageAction = 'delete';
                    this.DeleteInteraction(args.dataContext);
                  } else if (result.dismiss === Swal.DismissReason.cancel) {
                  }
                })

              }
            },


          ],
        }
      }

    ]


  }


  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    if (this.permission == 1 )
      return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
    else
      return '';
  };

  nameFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return '<div class="e-image"><img class="e-avatar" src="' + dataContext.userPhoto + '" alt="user"></div><span class="name"> ' + dataContext.displayNameEn + '</span>';
  };

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
  getCondition() {
    this.condition2_data = [
      { text: 'True', value: 'True' },
      { text: 'False', value: 'False' }
    ];
  }
  onChangeTab(val: any) {
    this.spinner.show();

    let temp = this;
    setTimeout(function () {
      temp.spinner.hide();
    }, 700);


  }
  changeSearch(val: any) {
    
    if (val == 'pr') {
      this.isPRSearch = true;
      this.exUser = false;
      this.externalUser = 0;
    }
    else if (val == 'nt') {
      this.isPRSearch = false;
      this.exUser = false;
      this.externalUser = 0;
    }
    else if (val == 'ex') {
      this.isPRSearch = false;
      this.exUser = true;
      this.externalUser = 1;
    }
 //this.isPRSearch = (val == 'pr') ? true : false;
    return false;
  }

  searchGrid() {
    
    if (this.searchText != "") {
      this.dataset = this.dataSearch.filter(a =>
        a.ntUsername && a.ntUsername.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.firstname && a.firstname.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.lastname && a.lastname.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.emailId && a.emailId.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.designationEn && a.designationEn.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.divisionNameEn && a.divisionNameEn.toLowerCase().includes(this.searchText.toLowerCase())));
    }
    else
      this.dataset = this.dataSearch;
  }

  getUserPermissionEntry(selectedUserUno: any) {
    
    this.spinner.show();
    let inpValue = new userpermission();
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.userUno = this.RASHelper.encryptWithPublicKey(selectedUserUno);
    inpValue.enteredBy = this.login_UserID;
    //inpValue.tenantUno = this.tenantUno;
    
    this.restApi.getUserPermission(inpValue)
      .subscribe(data => {
        
        this.userpermission_data = data;
        
        this.loading = false;
        this.spinner.hide();

      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }

  onSetDefaultTenant(itemUno: any) {

  }

  onRemoveTenant(itemUno: any) {
    let inpValue = new userpermission();
    inpValue.itemUno = itemUno;
    inpValue.condition = 1;
    inpValue.tenantUno = 0;
    inpValue.userTypeUno = 0;
    inpValue.userRoleUno = 0;
    inpValue.divisionUno = 0;
    inpValue.userUno = this.RASHelper.encryptWithPublicKey(this.selectedUserUno);
    inpValue.enteredBy = this.login_UserID;
    
    this.restApi.addEditUserPermission(inpValue)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
          // Swal.fire('Error', 'Something went wrong', 'error');
          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();
        }
        else {
          this.modalUserRef.hide();

          this.toaster.show('success', 'Success', 'Tenant Removed');
          this.clearEntryForm();
          this.spinner.hide();

        };

      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      })
    return false;
  }
  onAddTenant() {
    
    this.isSubmitted = true;



    if (!this.checkAllValue()) {
      let isCheckTenant: any=[];
      if (this.userpermission_data.length > 0) {
        isCheckTenant = this.userpermission_data.filter(x => x.tenantUno == parseInt(this.tenantNumber));
      }
      
      this.isSubmitted = false;

      if (isCheckTenant.length > 0) {
        this.toaster.show('error', 'Error', 'Duplicated Tenant is not allowed');
        return false;
      }
      else {
        let inpValue = new userpermission();
        inpValue.itemUno = 0;
        inpValue.condition = 0;
        inpValue.tenantUno = parseInt(this.tenantNumber);
        inpValue.userTypeUno = parseInt(this.userType);
        inpValue.userRoleUno = parseInt(this.userRole);
        inpValue.divisionUno = parseInt(this.division);
        inpValue.userUno = this.RASHelper.encryptWithPublicKey( this.selectedUserUno);
        inpValue.enteredBy = this.login_UserID;
        this.restApi.addEditUserPermission(inpValue)
          .subscribe(data => {
            
            if (data != null && data != undefined && data != '') {
              // Swal.fire('Error', 'Something went wrong', 'error');
              this.toaster.show('error', 'Error', 'Something went wrong');
              this.spinner.hide();
            }
            else {
              this.modalUserRef.hide();

              this.toaster.show('success', 'Success', 'Tenant Saved');
              this.clearEntryForm();
              this.spinner.hide();

            };

          },
            (error) => {
              //Called when error
              this.spinner.hide();
            }
          ).add(() => {
            //Called when operation is complete (both success and error)
            this.spinner.hide();
          })
      }
    }
    return false;
  }
  clearEntryForm() {
    this.tenantNumber = '';
    this.userRole = '';
    this.userType = '';
    this.division = '';
  }
  checkAllValue() {
    let rtnValue = false;
    if (this.tenantNumber == "" || this.userRole == "" || this.userType == "" || this.division == "") {
      rtnValue = true;
    }
    return rtnValue;
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  getTenantInfo(tenantUno: number) {
    this.spinner.show();
    let inpValue = new tenant();
    inpValue.languageUno = 1033;
    inpValue.itemUno = tenantUno;
    inpValue.condition = 2;
    inpValue.userUno = this.RASHelper.encryptWithPublicKey('1');
    inpValue.enteredBy = this.login_UserID;

    
    this.restApi.getTenants(inpValue)
      .subscribe(data => {
        
        this.user = this.userService.getUserInfo();
        var isDigitalUser = (tenantUno == this.user.tenantDigitalUno) ? true : false;
        let tenantData: any = data;
        if (tenantData != null && tenantData.length > 0) {
          this.user.slaname = tenantData[0].slaName;
          this.user.siteHeading = tenantData[0].siteHeading;
          this.user.isDynamicEntry = (tenantData[0].isDynamicEntry == 1) ? 'true' : 'false';

          this.user.currentYear = tenantData[0].currentYear;
          this.user.currentHalf = tenantData[0].currentHalf;
          this.user.currentMonth = tenantData[0].currentMonth;
          this.user.currentQuarter = tenantData[0].currentQuarter;
          this.user.wellperformKPIRange = tenantData[0].wellPerformKPIRange;
        }

        var struser = '{"id":"' + this.user.id + '","tenantDigitalUno":"' + this.user.tenantDigitalUno + '","tenantDigitalUser":"' + isDigitalUser + '","displayname":"' + this.user.displayname + '","username":"' + this.user.username + '","firstname":"' + this.user.firstname + '","lastname":"' + this.user.lastname + '","email":"' + this.user.email + '","role":"' + this.user.role + '","desingation":"' + this.user.desingation + '","division":"' + this.user.division + '","divisionUno":"' + this.user.divisionUno + '","profilePicture":"' + this.user.profilePicture + '","currentYear":"' + this.user.currentYear + '","currentHalf":"' + this.user.currentHalf + '","currentQuarter":"' + this.user.currentQuarter + '","currentMonth":"' + this.user.currentMonth + '","versionNumber":"' + this.user.versionNumber + '","wellperformKPIRange":"' + this.user.wellperformKPIRange + '","lastLogin":"' + this.user.lastLogin + '","tenantUno":"' + tenantUno + '","isDynamicEntry":"' + this.user.isDynamicEntry + '","siteHeading":"' + this.user.siteHeading + '","slaname":"' + this.user.slaname + '","userroleType":"' + this.user.userroleType + ',"userGroupUno":"' + this.user.userGroupUno + '","userGroup":"' + this.user.userGroup + '"}';
        localStorage.removeItem('userinfo');
        localStorage.setItem('userinfo', struser);

        // remove inbox filter:
        let inboxstVal = 'inbox_filter_musherat_storage';
        localStorage.removeItem(inboxstVal);

        setTimeout(() => {
          
          if (this.user.userroleType == 5 || this.user.userroleType == 6 || this.user.userroleType == 7 || this.user.userroleType == 8) {
            //this.router.navigate(['/benchmark-home']);

            window.location.href = "#/benchmark-home";
            window.location.reload();
          }
          else if (this.user.tenantUno == 6) {
            window.location.href = "bsc/dashboard";
          }
          else {
            window.location.href = "#/dashboard";
            window.location.reload();
            //this.router.navigate(['/dashboard']);
          }

        }, 1000);
        this.loading = false;
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  loadpairText() {
    
    let inpValue = new pairText();
    inpValue.k1 = '';
    this.restApi.callpairText(inpValue)
      .subscribe(data => {
        
        let rtnData: pairText;
        rtnData = data;
        this.strI1 = rtnData.k1;
        this.strI1 = rtnData.i1;
      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }
}

